<template>
    <div class="ext-header-box">
        <div class="ext-header-top">
            <div class="ext-header-top-main">
                <nav class="navbar ext-header-top-main-top">
                    <div class="ext-header-top-main-left">
                        <p></p>
                    </div>
                    <div class="ext-header-top-main-right">
                        <p>
                            <b>您好，{{user_info.store_name}}</b>
                            <a>
                                <router-link :to="{path:'/store/message',query:{}}">我的消息</router-link>
                                <i v-if="message_count>0" class="tip">{{message_count}}</i>
                            </a>
                            <a @click="$bvModal.show(modal_id)">
                                退出
                                <i></i>
                            </a>

                        </p>
                    </div>
                </nav>
                <div class="ext-header-logo">
                    <div class="ext-header-logo-left">
                        <div class="ext-header-logo-left-icon" @click="go_home()">
                            <img src="@/assets/icon/logo.png"/>
                            <p>弗兰卡再供应</p>
                        </div>
                    </div>
                    <div class="ext-header-logo-right">
                        <div class="ext-header-logo-right-l">
                            <div class="ext-header-search-top">
                                <div class="ext-header-search-box">
                                    <div class="ext-header-search-left-input">
                                        <input placeholder="按商品名称/商品编码" v-model="search_goods" @keyup.enter="search_data()" type="text"/>
                                    </div>
                                    <div @click="search_data()" class="ext-header-search-left-button">
                                        <img src="@/assets/icon/search.png"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ext-header-logo-right-r">
                            <div class="ext-header-cart">
                                <img src="@/assets/icon/cart.png"/>
                                <p>购物车</p>
                                <i>{{cart_count}}</i>
                                <div class="ext-cart-list-box">
                                  <h2>最新加入购物车</h2>
                                  <ul>
                                    <ext-cart v-if="cart_list.length==0" style="width:100%;" title="快去挑选喜欢的商品吧~"></ext-cart>
                                    <div class="ext-cart-list-box-scroll">
                                      <li v-for="(vo,index) in cart_list" :key="index">
                                        <img src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
                                        <p>{{vo.goods_name}}</p>
                                        <a>
                                          <b>￥{{vo.goods_money}} x {{vo.qty}}</b>
                                          <i @click="cart_delete(vo.goods_no)">删除</i>
                                        </a>
                                      </li>
                                    </div>
                                  </ul>
                                  <div v-if="no_freight_state==='1'">
                                    <h3 v-if="cart_full_state===1">
                                      <b>已满{{cart_full_fee}}元，已免运费</b>
                                      <span>小计：{{cart_goods_fee}}</span>
                                    </h3>
                                    <h3 v-else class="error">
                                      <b>金额差{{(cart_full_fee-cart_goods_fee).toFixed(2)}}元，可免运费</b>
                                      <span>小计：{{cart_goods_fee}}</span>
                                    </h3>
                                  </div>
                                  <h4>
                                    <b>共{{cart_goods_qty}}件商品</b>
                                    <a @click="order_submit()" class="order">去结算</a>
                                    <a @click="go_cart()" class="cart">去购物车</a>
                                  </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ext-header-nav">
                    <div class="ext-header-class">
                        <p>商品分类</p>
                    </div>
                    <div class="ext-header-menu">
                        <ul>
                            <li v-for="(vo,index) in home_menu" :key="index">
                                <p :id="['menu_'+vo.id]" :class="[vo.id==select_menu ? 'select' : '']" >
                                    <a @click="go_menu(vo.url)">{{vo.title}}</a>
                                </p>
                                <div v-if="vo.id==7" class="ext-phone-box">
                                  <i class="arrow"></i>
                                  <p>
                                    <img src="@/assets/icon/qrcode.png"/>
                                    <a>
                                      <b style="font-size:16px;">弗兰卡APP</b>
                                      <span style="font-size:14px;">新人领礼品</span>
                                    </a>
                                  </p>
                                  <p style="margin-top:90px;display: none;">
                                    <img src="@/assets/icon/qrcode.png"/>
                                    <a>
                                      <b>关注小程序</b>
                                      <span>新人领礼品</span>
                                    </a>
                                  </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="ext-header-class-left">
                        <ul>
                            <li v-for="(vo,index) in class_list" :key="index"  :class="[company_no!='MCD-CHN' ? 'subway' : '']">
                                <a @click="go_goods_class(vo.id)">{{vo.title}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>

        <b-modal :id="modal_id" centered  hide-footer>
          <template #modal-title>
            提示
          </template>
          <div class="d-block text-center">
            <h6>确认退出系统吗？</h6>
          </div>
          <div class="web-modal-foot">
            <a @click="$bvModal.hide(modal_id)">取消</a>
            <a @click="$bvModal.hide(modal_id);go_login()" class="ok">退出</a>
          </div>
        </b-modal>

        <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>
    </div>
</template>

<script>
import $ from 'jquery'
import {getUserId, ajax, Encrypt, Decrypt, webUrl, getCompanyNo} from '@/utils/extend'
import { M } from 'caniuse-lite/data/agents'
import ExtCart from '@/components/loading/cart'
import Toast from '@/components/toast/index'

export default {
  name: 'ExtHeader',
  components: {
    'ext-cart': ExtCart,
    'ext-toast': Toast
  },
  props: ['select_menu'],
  data () {
    return {
      msg: '这是首页',
      web_url: webUrl(),
      company_no: getCompanyNo(),
      modal_id: 'modal_id_1',
      search_goods: '',
      cart_list: [],
      cart_full_state: 0,
      cart_full_fee: 0,
      cart_goods_fee: 0,
      cart_count: 0,
      cart_goods_qty: 0,
      message_count: 0,
      home_menu: [],
      class_list: [],
      user_info: {},
      toast_state: 'display:none',
      toast_text: '',
      no_freight_state: 0
    }
  },
  mounted () {
    var params = this.$route.query
    if (Decrypt(params.search)) {
      this.search_goods = Decrypt(params.search)
    } else {
      this.search_goods = ''
    }

    this.modal_id = 'modal_id_' + (new Date()).valueOf()

    if (this.select_menu === '1') {
      $('.ext-header-class-left').show()
    } else {
      $('.ext-header-class').hover(function () {
        $('.ext-header-class-left').show()
      }, function () {
        $('.ext-header-class-left').hide()
        $('.ext-header-class-left ul li').removeClass('select')
      })

      $('.ext-header-class-left').hover(function () {
        $('.ext-header-class-left').show()
      }, function () {
        $('.ext-header-class-left').hide()
        $('.ext-header-class-left ul li').removeClass('select')
      })
    }

    $('.ext-header-class-left ul li').hover(function () {
      $('.ext-header-class-left ul li').removeClass('select')
      $(this).addClass('select')
    })

    $('#menu_7').hover(function () {
      $('.ext-phone-box').show()
    }, function () {
      $('.ext-phone-box').hide()
    })

    $('.ext-header-cart').hover(function () {
      $('.ext-cart-list-box').show()
    }, function () {
      $('.ext-cart-list-box').hide()
    })

    $('.ext-cart-list-box').hover(function () {
      $('.ext-cart-list-box').show()
    }, function () {
      $('.ext-cart-list-box').hide()
    })

    this.load_goods_class()
    this.load_user()
    this.load_cart_list()
    this.load_message()

    if (this.company_no === 'MCD-CHN') {
      this.home_menu = [
        {
          id: '1',
          title: '首页',
          url: '/',
          query: {}
        }, {
          id: '2',
          title: '全部商品',
          url: '/goods/goods_list',
          query: {v: Encrypt('all')}
        }, {
          id: '3',
          title: '收藏夹',
          url: '/store/collect',
          query: {}
        }, {
          id: '4',
          title: '文件下载',
          url: '/news/news_list',
          query: {}
        }, {
          id: '5',
          title: '我的订单',
          url: '/order/order_list',
          query: {classid: 1}
        }, {
          id: '6',
          title: '我的账号',
          url: '/store/store_info',
          query: {classid: 2}
        }, {
          id: '7',
          title: '手机APP',
          url: '',
          query: {}
        },
        {
          id: '8',
          title: '我的账单',
          url: '/store/store_bill',
          query: {}
        }
      ]
    } else {
      this.home_menu = [
        {
          id: '1',
          title: '首页',
          url: '/',
          query: {}
        }, {
          id: '2',
          title: '全部商品',
          url: '/goods/goods_list',
          query: {v: Encrypt('all')}
        }, {
          id: '3',
          title: '收藏夹',
          url: '/store/collect',
          query: {}
        }, {
          id: '4',
          title: '文件下载',
          url: '/news/news_list',
          query: {}
        }, {
          id: '5',
          title: '我的订单',
          url: '/order/order_list',
          query: {classid: 1}
        }, {
          id: '6',
          title: '我的账号',
          url: '/store/store_info',
          query: {classid: 2}
        }, {
          id: '7',
          title: '手机APP',
          url: '',
          query: {}
        }
      ]
    }
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 3000)
    },
    cart_delete (id) {
      var that = this
      var selectCartIds = id

      if (selectCartIds) {
        ajax({
          url: '/store/order/cart_list_del',
          method: 'post',
          data: {
            uid: getUserId(),
            ids: selectCartIds
          }
        }, function (ret) {
          if (ret && ret.code === 'success') {
            that.load_cart_list()
          }
        })
      } else {
        this.toast('请选择一个商品')
      }
    },
    go_menu (url) {
      var params = this.$route
      if (url === '') {
        console.log('')
      } else {
        this.$router.push({path: url, query: {}})
      }
    },
    go_goods_class (id) {
      var params = this.$route.query
      if (Decrypt(params.v) !== id) {
        this.$router.push({path: '/goods/goods_list', query: {v: Encrypt(id)}})
      }
    },
    go_home () {
      var params = this.$route
      if (params.name !== 'home') {
        this.$router.push({path: '/', query: {}})
      }
    },
    go_login () {
      var that = this
      ajax({
        url: '/store/api/logout',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        that.$router.push({path: '/login', query: {}})
      })
      localStorage.clear()
    },
    go_cart () {
      var params = this.$route
      if (params.name !== 'cart_list') {
        this.$router.push({path: '/cart/cart_list', query: {}})
      }
    },
    load_message () {
      var that = this
      ajax({
        url: '/store/user/get_message_count',
        method: 'post',
        data: {
          uid: getUserId(),
          user_id: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.message_count = ret.data.count_0
        } else {
          that.message_count = 0
        }
      })
    },
    load_goods_class () {
      var that = this
      ajax({
        url: '/store/goods/class_list_json',
        method: 'post',
        data: {
          uid: getUserId(),
          type: 'web'
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.class_list = ret.data
        } else {
          that.class_list = []
        }
      })
    },
    load_user () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.user_info = ret.data
        } else {
          that.user_info = {}
        }
      })
    },
    search_data () {
      var searchGoods = this.search_goods
      var params = this.$route.query
      if (Decrypt(params.search) !== searchGoods) {
        this.$router.push({path: '/goods/search_list', query: {search: Encrypt(searchGoods)}})
      }
    },
    order_submit () {
      var selectIds = ''
      var cartList = this.cart_list
      cartList.forEach(function (val) {
        selectIds += val['goods_no'] + ','
      })

      if (selectIds) {
        this.$router.push({path: '/cart/order_submit', query: {v: Encrypt(selectIds)}})
      } else {
        this.toast('请选择一个商品')
      }
    },
    load_cart_list () {
      var that = this
      ajax({
        url: '/store/order/user_cart_list',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          var spotList = ret.data.spot_list
          var stockoutList = ret.data.stockout_list
          var cartGoods = []
          var cartGoodsFee = 0
          var cartCount = 0

          spotList.forEach(function (val) {
            cartGoods.push({
              'id': val.id,
              'qty': val.qty,
              'goods_type': val.goods_type,
              'type_id': val.type_id,
              'integral': val.integral,
              'goods_no': val.goods_no,
              'goods_name': val.goods_name,
              'goods_remark': val.goods_remark,
              'goods_image': val.goods_image,
              'goods_money': val.goods_money,
              'goods_qty': val.goods_qty,
              'checked': false
            })

            cartGoodsFee += parseFloat(val.goods_money) * parseInt(val.qty)
            cartCount += 1
          })

          stockoutList.forEach(function (val) {
            cartGoods.push({
              'id': val.id,
              'qty': val.qty,
              'goods_type': val.goods_type,
              'type_id': val.type_id,
              'integral': val.integral,
              'goods_no': val.goods_no,
              'goods_name': val.goods_name,
              'goods_remark': val.goods_remark,
              'goods_image': val.goods_image,
              'goods_money': val.goods_money,
              'goods_qty': val.goods_qty,
              'checked': false
            })
            cartGoodsFee += parseFloat(val.goods_money) * parseInt(val.qty)
            cartCount += 1
          })

          if (cartGoodsFee >= ret.data.no_freight_fee) {
            that.cart_full_fee = ret.data.no_freight_fee
            that.cart_full_state = 1
          } else {
            that.cart_full_fee = ret.data.no_freight_fee
            that.cart_full_state = 0
          }

          that.no_freight_state = ret.data.no_freight_state

          that.cart_list = cartGoods
          that.cart_goods_fee = cartGoodsFee.toFixed(2)
          that.cart_count = cartCount
          that.cart_goods_qty = ret.data.all_qty
        } else {
          that.cart_list = []
          that.cart_goods_fee = '0.00'
          that.cart_full_fee = 0
          that.cart_count = 0
          that.cart_goods_qty = '0'
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }

input { box-sizing:border-box;outline:none;}

.ext-header-box { width:100%; height:155px; box-shadow: 0 1px 3px 0 rgba(0,0,0,.1);}
  .ext-header-top { width:100%; height:30px; background:#f5f5f5;}
  .ext-header-top-main { width:1000px; height:500px; margin:0px auto; padding:0px; flex-wrap:wrap; align-content:flex-start;}
  .ext-header-top-main-top { width:100%; height:30px;padding:0px; flex-flow:row; justify-content:space-between;}
    .ext-header-top-main-left { width:200px; height:30px; margin:0px; flex-flow:row; justify-content:flex-start;}
         .ext-header-top-main-left img { width: 16px; height:16px; margin:7px 5px 0px 0px;}
         .ext-header-top-main-left p { width:120px; height:30px; line-height:30px; font-size:12px; color:#666666;}
    .ext-header-top-main-right { width:750px; height:30px;}
        .ext-header-top-main-right p { width:100%; height:30px; flex-flow:row; justify-content:flex-end;}
            .ext-header-top-main-right p b { width:auto; height:30px; line-height:30px; font-weight: normal; font-size:12px; color:#666666; margin-right: 10px;}
            .ext-header-top-main-right p a { width:75px; height:30px; cursor: pointer; position: relative; justify-content:center; text-align: center; line-height:30px; font-size:12px; color:#666666;}
            .ext-header-top-main-right p a:hover { color: #333333;}
            .ext-header-top-main-right p a i { position: absolute; left:0px; top:8px; width:1px; height:14px; line-height: 14px; border-right:1px solid #cdcdcd;}
            .ext-header-top-main-right p a img { width: 16px; height:16px; margin-top:7px;}
            .ext-header-top-main-right p a i.tip { position: absolute; left:60px; top:0px; color:#ffffff; width:auto; height:16px; z-index: 999; line-height: 16px; font-style: normal; font-size: 12px; padding:0px 7px; border-radius: 45px; background: #d81e06;}

    .ext-header-logo { width:100%; height:80px; flex-flow:row; justify-content:space-between;}
        .ext-header-logo-left { width:400px; height:100px; flex-flow:row;justify-content:flex-start;}
            .ext-header-logo-left-icon { width:400px; height: 100px; cursor: pointer; margin-right:15px; flex-wrap:wrap; align-content:flex-start;}
                .ext-header-logo-left-icon img { width:auto; height: 50px; margin-top:15px;}
                .ext-header-logo-left-icon a { width:150px; height: 20px; letter-spacing:7px; line-height: 20px; color:#666666; font-size:15px; font-weight: bold; margin:0px;}
                    .ext-header-logo-left-icon a:hover { color:#666666;}
                    .ext-header-logo-left-icon p { width:200px; height:50px; line-height:50px; margin:15px 0px 0px 10px; font-size:18px; color:#333333;}

                    .ext-header-logo-left p { width:150px; height: 30px; margin-top:15px; margin-top:15px; flex-flow:row; justify-content:flex-start;}
            .ext-header-logo-left p img { width:16px; height: 16px; margin:8px 10px 0px 0px;}
            .ext-header-logo-left p b { width:70px; height:30px; line-height: 30px; font-weight: normal; color:#333333; font-size:13px;}
        .ext-header-logo-right { width:510px; height:100px;}
            .ext-header-logo-right-l { width:390px; height: auto; flex-wrap:wrap; align-content:flex-start; margin-top:33px;}
            .ext-header-logo-right-r { width:115px; height: auto; margin-top:33px;}
                .ext-header-cart { width:105px; height:34px; position: relative; margin-top:1px; cursor: pointer; margin-left:10px; border:1px solid #cccccc; flex-flow:row; justify-content:flex-start; background: #f6f7f9;}
                    .ext-header-cart img { width:16px; height:16px; margin:8px 5px 0px 10px;}
                    .ext-header-cart p { width:auto; height:34px; line-height: 34px; font-size:14px; color:#333333;}
                    .ext-header-cart i { width:auto; height:16px; position: absolute; top:8px; left:75px; font-size:14px; line-height: 16px; padding:0px 7px; border-radius: 45px;font-style:normal; color:#ffffff; background: #d81e06;}

                    .ext-cart-list-box { width:320px; height:363px;  position: relative; display: none; background: #ffffff; flex-wrap:wrap; align-content:flex-start; border:1px solid #dfdfdf; border-top:2px solid #dfdfdf; z-index: 99999; position: absolute; right:0px; top: 32px;}
                    .ext-cart-list-box h2 { width:100%; height:30px; line-height:30px; float:left; font-size:14px; color:#333333; margin:0px; padding:0px 10px; box-sizing: border-box; background: #efefef;}
                    .ext-cart-list-box ul { width:100%; height:260px; float:left; overflow: hidden; list-style: none; flex-wrap:wrap; align-content:flex-start; margin:0px; padding:0px; box-sizing: border-box;}
                    .ext-cart-list-box-scroll { width:100%; height:260px; float:left; overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling: touch;flex-wrap:wrap; align-content:flex-start;  }
                    .ext-cart-list-box ul li { width:300px; height:70px; float:left; padding:10px; border-bottom: 1px solid #efefef;}
                    .ext-cart-list-box ul li img { width:50px; height:50px; float:left; margin:0px 10px 0px 0px; }
                    .ext-cart-list-box ul li p { width:135px; height:50px; line-height:20px; margin:0px;  font-size:12px; color:#666666;float:left;}
                    .ext-cart-list-box ul li a { width:150px; height:50px; float:left; margin:0px 0px 0px 5px;flex-wrap:wrap; align-content:flex-start; }
                    .ext-cart-list-box ul li a b { width:120px; height:20px; line-height:20px; margin:0px;  font-size:12px; color:#d81e06; float:left;}
                    .ext-cart-list-box ul li a i { width:80px; height:20px; line-height:20px; position:static; cursor: pointer; background: #ffffff; margin:0px;  font-size:12px; color:#333333; float:left; margin-top:10px;}
                    .ext-cart-list-box h3 { width:100%; height:30px; line-height:30px;  justify-content:space-between;background: #bffab1; float:left; font-size:14px; color:#333333; margin:0px; padding:0px 10px; box-sizing: border-box; }
                    .ext-cart-list-box h3 a {  width:auto; height:20px; line-height: 20px; float:left; margin-top:5px; text-align: center; padding:0px 5px; background: #006400; font-size:14px; color:#ffffff; border-radius: 4px;}
                    .ext-cart-list-box h3 a:hover { color:#ffffff;}
                    .ext-cart-list-box h3 b { width:190px; height:20px; float:left; line-height:20px; margin-top:5px; font-size:14px; font-weight: normal; color:#333333;}
                    .ext-cart-list-box h3 span { width:auto; height:20px; float:right; text-align: right; line-height:20px; margin-top:5px; font-size:14px; font-weight: normal; color:#333333; margin-left:10px;}
                    .ext-cart-list-box h4 { width:100%; height:40px; position: absolute; left:0px; bottom: -10px; background: #efefef; float:left;}
                    .ext-cart-list-box h4 b { width:110px; height:40px; line-height:40px; float:left; margin-left:10px; font-weight: normal; font-size:14px; color:#333333;}
                    .ext-cart-list-box h4 a { width:auto; padding:0px 10px; height:28px; line-height:28px; margin-top:6px; font-size: 14px; color:#ffffff; border-radius: 4px; background: #d81e06;}
                    .ext-cart-list-box h4 a.order { color:#ffffff; margin-right:10px;}
                    .ext-cart-list-box h4 a.cart { color:#ffffff; background: #e9a90f;}

                    .ext-cart-list-box h3.error {  background: #bffab1;  justify-content:space-between;}

                .ext-header-search-top { width:390px; height: 38px;}
                    .ext-header-search-box { width:388px; height:36px; border:2px solid #d81e06; border-radius: 2px; flex-flow:row; justify-content:flex-start;}
                        .ext-header-search-left-input { width:331px; height:30px;}
                            .ext-header-search-left-input input { width:311px; height:28px;  border:0px; margin:0px; padding:0px 0px 0px 10px; min-height:28px; line-height:28px; margin-top:2px; font-size:14px; color:#333333;}
                        .ext-header-search-left-button { width:55px; height:32px; cursor: pointer; background: #d81e06;}
                            .ext-header-search-left-button img { width:24px; height: 24px; margin:4px 0px 0px 15px;}
                .ext-header-search-foot { width:390px; height: 20px;}
                    .ext-header-search-foot p { width:390px; height: 20px; flex-flow:row; justify-content:flex-start;}
                    .ext-header-search-foot p a { width:auto; max-width:150px; cursor: pointer; padding-right:30px; position: relative; height:20px; line-height: 20px; font-size:12px; }
                    .ext-header-search-foot p a:hover { color: #999999;}
                    .ext-header-search-foot p a b { width:auto; max-width:150px; font-weight: normal; overflow: hidden; cursor: pointer; height:20px; line-height: 20px; font-size:12px; color:#999999;}
                    .ext-header-search-foot p a i { position: absolute; left:-15px; top:4px; width:1px; height:12px; line-height: 12px; border-right:1px solid #999999;}

    .ext-header-nav { width:100%; height:45px; flex-flow:row; justify-content:flex-start; position: relative;}
        .ext-header-class { width:240px; height:45px; margin-right: 20px;}
            .ext-header-class p { width:240px; height:45px; line-height: 45px; cursor: pointer; font-size: 16px; text-align: center; background: #d81e06; color:#ffffff; justify-content:center;}
        .ext-header-menu { width:760px; height:45px;}
            .ext-header-menu ul { width:820px; height:45px; margin:0px; padding:0px; list-style: none; flex-flow:row; justify-content:flex-start;}
                .ext-header-menu ul li { width:auto; height:45px; display: block; position: relative; padding:0px 10px; line-height:45px; font-size: 16px; color:#333333;}
                .ext-header-menu ul li p { color:#333333; cursor: pointer;text-decoration:none;}
                .ext-header-menu ul li p a { color:#333333; cursor: pointer;text-decoration:none;}
                .ext-header-menu ul li p a:hover { color:#d81e06;}
                .ext-header-menu ul li p.select a { color:#d81e06; font-weight: bold;text-decoration:none;}
                .ext-header-menu ul li p.select a:hover{ color:#d81e06; font-weight: bold;}

  .ext-header-class-left { width:240px; height:400px; display: none; padding-bottom: 20px; overflow: hidden; position: absolute; left:0px; top:44px;  z-index: 999; border-left:2px solid #d81e06; border-bottom:2px solid #d81e06; border-right:2px solid #d81e06; background: #ffffff;}
      .ext-header-class-left ul { width:240px; height:auto; padding-left:20px; list-style:none; margin:0px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
          .ext-header-class-left ul li { width:70px;  height:45px; margin:0px; display: block; cursor: pointer; line-height: 45px;}
          .ext-header-class-left ul li.subway { width:100%;  height:35px; margin:0px; display: block; cursor: pointer; line-height: 35px;}
          .ext-header-class-left ul li a { color:#333333; font-size:12px;}
          .ext-header-class-left ul li a:hover { color:#d81e06; font-size:12px; font-weight: bold;}
          .ext-header-class-left ul li.select { width:70px; height:45px;}
          .ext-header-class-left ul li.select a { color:#d81e06; font-size:12px; font-weight: bold;}

          .ext-phone-box { width:240px; height:143px; display: none; z-index: 999999; background: #ffffff; position: absolute; top:44px; left:0px; border-top:1px solid #cccccc; border-left:1px solid #cccccc; border-right:1px solid #cccccc; border-bottom:3px solid #cccccc;}
                  .ext-phone-box p { width:238px; height:140px; padding:10px; box-sizing: border-box; background: #ffffff; position: absolute; top:0px; left:0px; border-bottom: 1px solid #cccccc;}
                  .ext-phone-box p img { width:120px; height:120px; float:left; margin-right:10px;}
                  .ext-phone-box p a { width:140px; height:120px; float:left;flex-wrap:wrap; align-content:flex-start;}
                  .ext-phone-box p a b { width:100%; height:20px;  margin-top:30px;line-height:30px;float:left; font-size:12px; color:#333333;}
                  .ext-phone-box p a span { width:100%; height:20px; line-height:30px;float:left; font-size:12px; color:#333333;}
                .arrow{
                  position: relative;
                  top:-20px;
                  left:20px;
                }
                .arrow:before,.arrow:after{
                  position: absolute;
                  content: '';
                  border-top: 10px transparent dashed;
                  border-left: 15px transparent dashed;
                  border-right: 15px transparent dashed;
                  border-bottom: 10px #fff solid;
                }
                .arrow:before{
                  border-bottom: 20px #cccccc solid;
                }
                .arrow:after{
                  top: 2px; /*通过覆盖调整箭头粗细*/
                  border-bottom: 20px #fff solid;
                }
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue